export default "__VITE_ASSET__CEBpTezv__"